import { BaseService } from '../../infra/base.service'
import type { Creative } from './creative'
import type { CreativesRepository } from './creatives.repository'

export class CreativesService extends BaseService<Creative> {
    constructor(private rep: CreativesRepository) {
        super(rep)
    }

    async syncWabaTemplates(): Promise<any> {
        return await this.rep.syncWabaTemplates()
    }

    async addDefaultTemplates(wabaId: string): Promise<any> {
        return await this.rep.addDefaultTemplates(wabaId)
    }
}
